import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Public Pages
const Home = lazy(() => import("./Home"));
const ProductsPage = lazy(() => import("./products"));
const Login = lazy(() => import("./Login"));
const Signup = lazy(() => import("./Signup"));
const UserDashboard = lazy(() => import("./UserDashboard"));
const AdminDashboard = lazy(() => import("./AdminDashboard"));

const LoadingFallback = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <div className="loading-spinner"></div>
  </div>
);

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable devtools shortcuts
    const handleKeyDown = (e) => {
      if (e.key === "F12") e.preventDefault();
      if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J"))
        e.preventDefault();
      if (e.ctrlKey && e.key === "U") e.preventDefault();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* User Dashboard Route */}
          <Route path="/user-dashboard/*" element={<UserDashboard />} />
          {/* Admin Dashboard Route */}
          <Route path="/admin-dashboard/*" element={<AdminDashboard />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
